module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/widget/widget.component.scss
// module id = ./src/app/components/account/widget/widget.component.scss
// module chunks = main